<template>
  <div class="md-layout">
    <!-- 表格-展示所有相关的交流记录 -->
    <div v-if="chat_mode === false" class="md-layout-item md-size-100">
      <!-- 表格 
        用户(ID)
        问题主题
        设备ID
        联系方式
        状态 [1:已反馈, 2:处理中, 3:已解决]
        更新时间
        反馈时间
        操作 (打开对话栏)
       -->
      <md-table v-model="tabel_data">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="$I18n('user')">{{ item.user_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('themes')">{{ item.title }}</md-table-cell>
          <md-table-cell :md-label="$I18n('dev_snid')">{{ item.uid }}</md-table-cell>
          <md-table-cell :md-label="$I18n('contact')">{{ item.contact }}</md-table-cell>
          <md-table-cell :md-label="$I18n('status')">{{ item.state_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time_str }}</md-table-cell>
          <md-table-cell :md-label="$I18n('feedback_time')">{{ item.create_time_str }}</md-table-cell>
          <md-table-cell :md-label="$I18n('operate')"  class="button-box">
            <md-button @click="table_goFeedbackChat(item)" @click.stop class="md-just-icon md-round md-info left-icon"><md-icon>question_answer</md-icon></md-button>
          </md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
      </md-table>
      <md-card-actions v-if="table_dataCount > 0" md-alignment="space-between">
        <!-- 翻页 -->
        <div class="total-page">
          <p class="card-category">{{`${$I18n("total")} : ${table_dataCount}`}}</p>
        </div>
        <pagination v-model="table_pageNo" :per-page="pageSize" :total="table_dataCount" class="pagination-no-border right-button" type= "info" />
      </md-card-actions>
    </div>
    <!-- 聊天功能 -->
    <div v-else class="md-layout-item md-size-100">
      <h3 :style="{'text-align' : 'center','line-height':'51px'}">
        {{chat_data.title}}
        <!-- 按钮-返回表格页面 -->
        <md-button @click="chat_goFeedbackTable" :style="{'float':'right'}" class="md-simple md-info md-just-icon" >
          <md-icon>reply</md-icon>
        </md-button>
      </h3>
      <!-- 聊天内容展示 -->
      <div v-for="item in chat_message" :key="item.id" :class="{'left_box': item.type === 1, 'right_box': item.type === 2}">
          <div class="name">{{item.user_id}}</div>
          <div>
              <!-- 用户样式部分 -->
              <div v-if="item.type === 1" class="face left">
                <icon-customer/>
              </div>
              <!-- 内容 -->
              <div class="message">{{item.content}}</div>
              <!-- 客服样式部分 -->
              <div v-if="item.type === 2" class="face right">
                <icon-custservice/>
              </div>
          </div>
          <!-- 时间 -->
          <div class="time">{{item.create_time_str}}</div>
      </div>
      <!-- 输入框+ -->
      <div class="md-layout" :style="{'clear':'both'}">
        <div class="md-layout-item md-size-20">
          <md-field >
            <md-select v-model="chat_data.state" >
              <md-option value="1" >{{$I18n("have_feed")}}</md-option>
              <md-option value="2" >{{$I18n("process")}}</md-option>
              <md-option value="3" >{{$I18n("resolved")}}</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="md-layout-item md-size-70">
          <md-field >
            <md-input v-model="chat_data.new_content"/>
          </md-field>
        </div>
        <div :style="{'text-align':'rigth'}" class="md-layout-item md-size-10">
          <md-button class="md-info  md-just-icon" @click="api_uploadFeedback">
            <md-icon>upload</md-icon>
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination } from "@/components";
import { timestampToString} from "@/common/tools.js"; // nDaysAgo ,
import { IconCustomer, IconCustservice } from "@/components/IconSvg";
export default {
  components: {
    Pagination,
    IconCustomer,
    IconCustservice,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
  },
  data(){
    return {
      tabel_rawData : [],  // 表格-原始数据
      table_pageNo : 1,    // 表格-所在页数
      table_dataCount : 0, // 表格-数据总数
      pageSize : 10,       // 表格-页面大小
      chat_mode : false,   // 是否是对话模式
      chat_data: {},       // 对话-数据
      chat_message : [],   // 对话-数据列表
    }
  },
  methods:{
    api_getFeedback(){ // api-获取反馈数据列表
      this.$api.getFeedbackList({ // api: /user/feedback/query
        app_id : this.app_id,
        page_no: this.table_pageNo,
        page_size: this.pageSize,
      })
        .then(this.$Then(res => {
          this.tabel_rawData = res.data
          this.table_dataCount = res.count
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tabel_rawData = [];
          this.table_dataCount = 0;
        }))
    },
    api_uploadFeedback(){ // api-更新反馈的状态(以及对话内容)
      this.$api.modifyFeedback({ // api: /user/feedback/modify
        ...this.chat_data,
      })
        .then(this.$Then(() => {
          if(this.chat_data.new_content !== "") { // 如果输入框有内容则额外更新对话数据并更新对话数据
            this.$api.addNewFeedbackMsg({ // api: /user/feedback/detail/add
              title_id : this.chat_data.id,
              type     : 2,
              content  : this.chat_data.new_content,
              user_id  : this.UserInfo.user_id,
            })
              .then(this.$Then(() => {
                this.$api.getFeedbackDetail({ // api: /user/feedback/detail/query
                  title_id : this.chat_data.id,
                })
                  .then(this.$Then(res => {
                    this.chat_data.new_content = "";
                    this.chat_message = res.data.map(item =>{
                      return {
                        ...item,
                        create_time_str: timestampToString(item.create_time * 1000),
                      }
                    });
                  }))
                  .catch(this.$Catch(this.$I18n("get_error")))
              }))
              .catch(this.$Catch(this.$I18n("get_error")))
          }
          this.api_getFeedback()
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    table_goFeedbackChat(item) { // 表格-打开对话页面
      this.$api.getFeedbackDetail({ // api: /user/feedback/detail/query
        title_id : item.id,
      })
        .then(this.$Then(res => {
          this.chat_mode = true;
          this.chat_data = {...item}
          this.chat_message = res.data.map(item =>{
            return {
              ...item,
              create_time_str: timestampToString(item.create_time * 1000),
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    chat_goFeedbackTable () { // 对话-打开表格页面
      this.chat_mode = false;
      this.chat_data = {}
    },
  },
  computed: {
    tabel_data(){ // 
      return this.tabel_rawData.map(item => {
        let state_name = this.$I18n("unknow_state")
        switch (item.state) {
          case 1: // 已反馈
            state_name = this.$I18n("have_feed")
            break
          case 2: // 处理中
            state_name = this.$I18n("process")
            break
          case 3: // 待解决
            state_name = this.$I18n("resolved")
            break
          default:
            break
        }
        let update_time_str = timestampToString(item.update_time * 1000)
        let create_time_str = timestampToString(item.create_time * 1000)
        return {
          ...item,
          state_name,
          update_time_str,
          create_time_str,
        }
      })
    },
  },
  created(){
    this.api_getFeedback()
  },
}
</script>
<style type="text/css" scoped>
  .right_box{
      margin: 8px 16px;
      width: 70%;
      max-width: 400px;
      float: right;
      clear: both;
  }
  .left_box{
      margin: 8px 16px;
      width: 70%;
      max-width: 400px;
      float: left;
      clear: both;
  }
  .name {
      font-size: 16px;
      line-height: 24px;
  }
  .right_box .name {
      margin-right: 44px;
      text-align: right;
  }
  .left_box .name {
      margin-left: 44px;
      text-align: left;
  }
  .message {
      width: calc(100% - 44px);
      border: 2px solid #ccc;
      padding: 6px;
      color: #000000;
      border-radius: 8px;
      margin-top: 4px;
      line-height: 20px;
      font-size: 14px;
      word-wrap:break-word;
      text-align: left;
      float: left;
  }
  .face.left {
      float: left;
      margin-top: 4px;
  }

  .face.right {
      float: right;
      margin-top: 4px;
  }
  .left_box .message{
      margin-left: 8px;
  }
  .right_box .message{
      margin-right: 8px;
  }
  .time{
      clear: both;
      font-size: 12px; 
      color: #999;
  }
  .right_box .time{
      margin-right: 44px; 
      text-align: right;
  }
  .left_box .time{
      margin-left: 44px; 
      text-align: left;
  }
</style>